function renderColumnsValueTemplate({
  accessor,
  tableColumnSize,
  buildSortableHeaderDefBuildSortableHeaderDef,
  fTextarea
}: {
  accessor: string
  tableColumnSize: number
  buildSortableHeaderDefBuildSortableHeaderDef: string
  fTextarea: string
}): string {
  return `  {
    accessorKey: '${accessor}',
    size: ${tableColumnSize},
    ${buildSortableHeaderDefBuildSortableHeaderDef},
    cell: ({ row }) => {
      const value = row.getValue('${accessor}')
      return <div>${fTextarea}</div>
    }
  }`
}

function renderColumnsLayoutTemplate({ pascal }: { pascal: string }): string {
  return `  {
    id: 'actions',
    size: 64,
    enableResizing: false,
    meta: { width: '64px' },
    header: () => <span className="sr-only">Actions</span>,
    cell: ({ row }) => (
      <div className="flex justify-end">
        <${pascal}Actions id={row.original.id} />
      </div>
    )
  }`
}

function renderColumnsClientModuleTemplate({
  pascal,
  actionImportPath,
  actionsImport,
  hasBadgeBadge,
  columnDefsContent,
  actionsColumnContent
}: {
  pascal: string
  actionImportPath: string
  actionsImport: string
  hasBadgeBadge: string
  columnDefsContent: string
  actionsColumnContent: string
}): string {
  return `'use client'

import { SortIndicator } from '@admin/components/shared/sort-indicator'
import type { ${pascal}SubmissionData } from '@admin/actions/${actionImportPath}'
${actionsImport}${hasBadgeBadge}import { Button } from '@admin/components/ui/button'
import { Checkbox } from '@admin/components/ui/checkbox'
import type { ColumnDef } from '@tanstack/react-table'

export const columns: ColumnDef<${pascal}SubmissionData>[] = [
  {
    id: 'select',
    size: 50,
    enableResizing: false,
    meta: { width: '50px' },
    header: ({ table }) => (
      <div className="flex items-center">
        <Checkbox
          checked={table.getIsAllPageRowsSelected() || (table.getIsSomePageRowsSelected() && 'indeterminate')}
          onCheckedChange={(value: boolean) => table.toggleAllPageRowsSelected(!!value)}
          aria-label="Select all"
        />
      </div>
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={(value: boolean) => row.toggleSelected(!!value)}
        aria-label="Select row"
      />
    ),
    enableSorting: false,
    enableHiding: false
  },
${columnDefsContent}${actionsColumnContent}
]
`
}

export function renderAdminColumnsRenderer(
  request:
    | {
        kind: 'renderColumnsValueTemplate'
        props: {
          accessor: string
          tableColumnSize: number
          buildSortableHeaderDefBuildSortableHeaderDef: string
          fTextarea: string
        }
      }
    | { kind: 'renderColumnsLayoutTemplate'; props: { pascal: string } }
    | {
        kind: 'renderColumnsClientModuleTemplate'
        props: {
          pascal: string
          actionImportPath: string
          actionsImport: string
          hasBadgeBadge: string
          columnDefsContent: string
          actionsColumnContent: string
        }
      }
): string {
  switch (request.kind) {
    case 'renderColumnsValueTemplate':
      return renderColumnsValueTemplate(request.props)
    case 'renderColumnsLayoutTemplate':
      return renderColumnsLayoutTemplate(request.props)
    case 'renderColumnsClientModuleTemplate':
      return renderColumnsClientModuleTemplate(request.props)
  }

  throw new Error('Unsupported renderer request')
}
